const blacklistedFieldNames = [
  "parts",
  "processes",
  "devices",
  "procedures",
  "partitionkey",
  "id",
  "createdby",
  "createdat",
  "isdeleted",
  "updatedby",
  "updatedat",
];

export const fieldNameValidator = (name, intl) => {
  if (!name) return null;

  const invalidName = blacklistedFieldNames.find(
    (x) => x === name.toLowerCase()
  );

  if (invalidName) {
    return Promise.reject(
      new Error(
        intl.formatMessage(
          { id: "validationErrors.invalidFieldName" },
          { fieldName: name }
        )
      )
    );
  }

  return Promise.resolve();
};
